import { REHYDRATE } from 'redux-persist';

import api from 'src/services/api';

const setToken = () => (next) => (action) => {
  if (action.type === REHYDRATE) {
    api.defaults.headers.Authorization = `Bearer ${action?.payload?.token}`;
  }
  next(action);
};

export default setToken;
